export default __webpack_public_path__ + "static/media/Seguimiento-de-obras.07b50c1b.png";